
import React, { useState, useEffect, JSX, use } from "react";
import FilterListIcon from "../../assets/images/FilterImg.svg";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  Button,
  Box,
  Grid,
  CircularProgress,
  Typography,
  Stack,
  SelectChangeEvent,
  Card,
  CardContent
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useSalesContext } from '../../Pages/SalesContext';
import { styled } from "@mui/material/styles";
import { API_BASE_URL2 ,API_BASE_URL} from "../../config/config.js";
import CustomerCoverageTable from "./CustomerCoverageTable";
import styles from "../css/CustomerCoverageData.module.css";
import clsx from "clsx"; // install via `npm install clsx` if not already


interface RouteParams {
  userId: string;
  user_data : any;
}

interface KpiData {
  card_summary: any;
  Days?: {
    FW_Days?: any | null;
  };
  Call?: {
    A_Call_Avg?: any | null;
    DR_Call_Avg?: any | null; // changed from Doctor_Call_Avg
  };
  Coverage?: {
    Unique_Cvrg_Per?: number |any | null;
    Freq_Cvrg_Per?: number |any | null;
  };
  Flm_Coverage?: {
    FLM_L5M_A_Cvrg_Per?: number |any | null; // changed from FLM_L5M_A_class_Cvrg_Per
  };
}



const selectStyles = {
  maxWidth: 260,
  height: 22,
  minWidth: 130,
  borderRadius: "1px",
  borderWidth: "1px",
  gap: "4px",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  textTransform: "uppercase",
  padding: "0",
  "& .MuiSelect-select": {
    width: "100%",
    textTransform: "uppercase",
    textOverflow: "clip",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  "& .MuiSelect-icon": {
    marginLeft: "20px",
    right: "5px",
  },
};
const customLabelMap: Record<string, string> = {
  FLM_L5M_A_Cvrg_Per: 'FLM’s L5M “A class” Cvrg.%',
  FW_Days: 'Field Work Days',
  A_Call_Avg: 'A Class Call Avg',
  DR_Call_Avg: 'Dr Call Avg',
  Unique_Cvrg_Per: 'Unique  Coverage %',
  Freq_Cvrg_Per: 'Frequency Compliance %'
  // Add other keys if needed
};

const fallbackData: KpiData = {
  Days: {
    FW_Days: 0,
  },
  Call: {
    A_Call_Avg: 0,
    DR_Call_Avg: 0,
  },
  Coverage: {
    Unique_Cvrg_Per: "0%",
    Freq_Cvrg_Per: "0%",
  },
  Flm_Coverage: {
    FLM_L5M_A_Cvrg_Per: "0%",
  },
  card_summary: undefined
};
const isValidData = (data: any): boolean => {
  return data && typeof data === "object" && Object.keys(data).length > 0;
};


interface CustomerCoverageDataProps {
  user_id?: any;
  user_data?: any;
}

const CustomerCoverageData: React.FC<CustomerCoverageDataProps> = React.memo(({ user_id, user_data }) => {
  const { setKpiData, setLoading } = useSalesContext();
console.log("User ID from URL:", user_id , user_data);
  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth() + 1 // Default: current month
  );
  const [activeCard, setActiveCard] = useState<string>("Days");
  const [kpiData, setKpiDataState] = useState<KpiData | null>(null);
  const [filterData, setFilterData] = useState<any>(null);
  const [userRole, setUserRole] = useState<string>("");
  const [userIdState, setUserId] = useState<string | null>(null);

  const months: string[] = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const getEffectiveYear = (selectedMonthIndex: number): number => {
  const now = new Date();
  const currentMonthIndex = now.getMonth(); // 0-based (Jan = 0)
  const currentYear = now.getFullYear();

  // selectedMonthIndex is 1-based in your code
  return selectedMonthIndex - 1 <= currentMonthIndex
    ? currentYear
    : currentYear - 1;
};

useEffect(() => {
  const fetchFilterAndKPIData = async () => {
    const fallbackUserId = "demouser74@mankind.com";
 const userObject = user_id; // Your user object
    const userId2 = user_id; // Extract user_id from the object
    console.log(userId2);
    const finalUserId = userId2 ? userId2 : fallbackUserId;

    try {
      const filterResponse = await fetch(
        `${API_BASE_URL}Filters/Filters?userId=${finalUserId}&userType=SAP_USER`
      );
      const filterJson = await filterResponse.json();

      const userRoleFetched = filterJson.user_Details.user_Role;
      const userIdFetched = filterJson.user_Details.user_Id;

      setFilterData(filterJson);
      setUserRole(userRoleFetched);
      setUserId(userIdFetched);

      console.log("Filter Data:", filterJson);

      // Fetch KPI after Filter data is successfully retrieved
      setLoading(true);
      const effectiveYear = getEffectiveYear(selectedMonth);
      const kpiResponse = await fetch(
        `${API_BASE_URL}CustomerCoverage/DashboardSummary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: userIdFetched,
            userRole: userRoleFetched,
             month: months[selectedMonth - 1],
              year: effectiveYear.toString(),
          }),
        }
      );

      const kpiJson: KpiData = await kpiResponse.json();
      console.log("KPI API Response:", kpiJson);

      if (isValidData(kpiJson)) {
        setKpiDataState(kpiJson);
        setKpiData(kpiJson);
      } else {
        setKpiDataState(fallbackData);
        setKpiData(fallbackData);
      }
    } catch (error) {
      console.error("Error fetching Filter or KPI data:", error);
      setKpiDataState(fallbackData);
      setKpiData(fallbackData);
    } finally {
      setLoading(false);
    }
  };

  fetchFilterAndKPIData();
}, [selectedMonth, user_id , user_data]); // Reacts to month/user change


  const handleMonthChange = (event: SelectChangeEvent<number>) => {
    setSelectedMonth(Number(event.target.value));
  };

  const getValueWithFallback = <T,>(
    value: T | undefined | null,
    fallback: T
  ): T | string => {
    return value === null ? "" : value ?? fallback;
  };
  const formatLabel = (key: string): string => {
  return key
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
};


const renderCard = (
  label: string,
  value: Record<string, string | number | null | undefined> | string | number | null | undefined,
  key: string
) => {
  const getCardClass = () => {
    switch (key) {
      case "Days":
        return styles.daysCard;
      case "Calls":
        return styles.callCard;
      case "Coverage":
        return styles.coverageCard;
      case "Flm_Coverage":
        return styles.flmCoverageCard;
      default:
        return "";
    }
  };
 const isActive = activeCard === key;
const formatLabel = (key: string): string => {
  if (customLabelMap[key]) return customLabelMap[key];

  const formatted = key
    .replace(/_/g, " ")
    .replace(/Per\b/i, "%")
    .replace(/\b\w/g, char => char.toUpperCase());
  if (formatted.length <= 15) return formatted;

  const words = formatted.split(" ");
  let lines: string[] = [];
  let currentLine = "";

  words.forEach(word => {
    if ((currentLine + " " + word).trim().length <= 15) {
      currentLine = (currentLine + " " + word).trim();
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  });
  if (currentLine) lines.push(currentLine);

  return lines.join("<br/>");
};


const formatValue = (valueItem: string | number | null | undefined, keyItem: string): string => {
  if (valueItem == null) return "";

  if (typeof valueItem === "number") {
    const keyLower = keyItem.toLowerCase();
    
    // No decimals for day or call values
    if (keyLower.includes("day") ) {
      return valueItem.toFixed(0);
    }
 if (keyLower.includes("call") ) {
      return valueItem.toFixed(1);
    }
    // Format percentages
    if (keyLower.includes("per")) {
      return `${valueItem.toFixed(2)}%`;
    }

    return valueItem.toFixed(2); // fallback
  }

  if (typeof valueItem === "string" && keyItem.toLowerCase().includes("per")) {
    return valueItem.trim().endsWith("%") ? valueItem.trim() : `${valueItem.trim()}%`;
  }

  return valueItem;
};


 
  return (
    <Card
      key={key}
      onClick={() => setActiveCard(key)}
      className={clsx(styles.card, getCardClass())}
       sx={{
        border: isActive ? "2px solid #1976d2" : "2px solid #ccc",
        borderRadius: isActive ? "20px" : "20px",
        background: isActive ? " #454088 !important" : "#fff",
        color: isActive ? "#fff" : "inherit",
        cursor: "pointer",
        height : '150px !important',
      }}
    >
   <CardContent className={styles.cardContent}>
<Typography
  sx={{
    color: isActive ? "#fff" : "#454088",
    fontWeight: 700,
    fontSize: "16px"
  }}
>
  {label}
</Typography>

  {typeof value === "object" && value !== null ? (
    Object.entries(value).map(([keyItem, valueItem]) => (
      <Box
        key={keyItem}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 0.5 }}
      >
        <Typography  sx={{ fontWeight: 500  ,fontSize:"12px" , mt:1.0}}>
          {formatLabel(keyItem)}
        </Typography>
        <Typography sx={{ fontSize:"12px" , mt:1.0}}>
          {formatValue(valueItem, keyItem)}
        </Typography>
      </Box>
    ))
  ) : (
              <Typography variant="body1">{typeof value === "object" ? JSON.stringify(value) : value.toFixed(2) ?? ""}</Typography>
  )}
</CardContent>

    </Card>
  );
};


const daysFW = getValueWithFallback(
  kpiData?.Days?.FW_Days,
  fallbackData.Days.FW_Days
);
const aCallAvg = getValueWithFallback(
  kpiData?.Call?.A_Call_Avg,
  fallbackData.Call.A_Call_Avg
);
const uniqueCoverage = getValueWithFallback(
  kpiData?.Coverage?.Unique_Cvrg_Per,
  fallbackData.Coverage.Unique_Cvrg_Per
);
const flmCoverage = getValueWithFallback(
  kpiData?.Flm_Coverage?.FLM_L5M_A_Cvrg_Per,
  fallbackData.Flm_Coverage.FLM_L5M_A_Cvrg_Per
);


  return (
    <>
      <div className="new-filter-bar-sticky">
        <div className="filter-container">
          <img src={FilterListIcon} alt="Filter Icon" className="filter-icon" />
          <Grid
            container
            spacing={2}
            sx={{ flexWrap: "nowrap", alignItems: "center" }}
          >
            <Grid item>
              <InputLabel>Month</InputLabel>
              <Select
                value={selectedMonth}
                onChange={handleMonthChange}
                size="small"
                sx={selectStyles}
              >
                {months.map((month, index) => (
                  <MenuItem key={index} value={index + 1}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </div>
      </div>

    <Box className={clsx(styles["customer-container"])} sx={{ p: 2 }}>
  <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
{renderCard("Days", kpiData?.Days ?? fallbackData.Days, "Days")}
{renderCard("Calls", kpiData?.Call ?? fallbackData.Call, "Calls")}
{renderCard("Coverage", kpiData?.Coverage ?? fallbackData.Coverage, "Coverage")}
{renderCard("FLM Coverage", kpiData?.Flm_Coverage ?? fallbackData.Flm_Coverage, "Flm_Coverage")}
  </Stack>
</Box>



      <CustomerCoverageTable
        activeCard={activeCard}
        selectedMonth ={months[selectedMonth - 1]}
        userId={filterData?.user_Details?.user_Id || userIdState }
        userRole={filterData?.user_Details?.user_Role || userRole}
       
      />
    </>
  );
});

export default CustomerCoverageData;


